import React from "react";
import { Box, MenuItem, Select, Stack, Typography } from "@mui/material";
import BusinessCenterOutlinedIcon from "@mui/icons-material/BusinessCenterOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";

const BRAND_BLUE = "#00336C";
const CONTACT_SEARCH_SCOPES = [
  { value: "executives", label: "Executives Only", description: "Find company leaders", Icon: BusinessCenterOutlinedIcon },
  { value: "all_employees", label: "All Employees", description: "Search across the company", Icon: GroupsOutlinedIcon },
];

export default function ContactSearchScopeSelect({ value, onChange, disabled }) {
  return (
    <Select
      size="small"
      value={value}
      onChange={onChange}
      disabled={disabled}
      inputProps={{ "aria-label": "Contact search scope" }}
      IconComponent={ExpandMoreRoundedIcon}
      renderValue={(value) => {
        const scope = CONTACT_SEARCH_SCOPES.find((option) => option.value === value);
        const ScopeIcon = scope.Icon;
        return (
          <Stack direction="row" spacing={1} alignItems="center">
            <ScopeIcon sx={{ fontSize: 20 }} />
            <span>{scope.label}</span>
          </Stack>
        );
      }}
      MenuProps={{
        PaperProps: {
          sx: {
            mt: 0.75,
            minWidth: 260,
            borderRadius: 2.5,
            border: "1px solid rgba(0,51,108,0.12)",
            boxShadow: "0 8px 28px rgba(0,51,108,0.14)",
            "& .MuiMenu-list": { p: 0.75 },
          },
        },
      }}
      sx={{
        minWidth: 220,
        backgroundColor: "white",
        color: BRAND_BLUE,
        fontSize: "0.875rem",
        fontWeight: 600,
        borderRadius: 2,
        "& .MuiSelect-select": { py: 1.25 },
        "& .MuiSelect-icon": { color: BRAND_BLUE },
        "& .MuiOutlinedInput-notchedOutline": { borderColor: "rgba(0,51,108,0.2)" },
        "&:hover .MuiOutlinedInput-notchedOutline": { borderColor: BRAND_BLUE },
        "&.Mui-focused .MuiOutlinedInput-notchedOutline": { borderColor: BRAND_BLUE },
      }}
    >
      {CONTACT_SEARCH_SCOPES.map(({ value: selectedValue, label, description, Icon }) => (
        <MenuItem
          key={selectedValue}
          value={selectedValue}
          sx={{
            color: BRAND_BLUE,
            borderRadius: 1.75,
            px: 1.5,
            py: 1.25,
            gap: 1.25,
            "& + &": { mt: 0.5 },
            "&:hover": { backgroundColor: "rgba(0,51,108,0.04)" },
            "&.Mui-selected": { backgroundColor: "rgba(0,51,108,0.07)" },
            "&.Mui-selected:hover": { backgroundColor: "rgba(0,51,108,0.1)" },
          }}
        >
          <Icon sx={{ fontSize: 22 }} />
          <Box sx={{ flex: 1 }}>
            <Typography sx={{ fontSize: "0.875rem", fontWeight: 700 }}>{label}</Typography>
            <Typography sx={{ fontSize: "0.75rem", color: BRAND_BLUE, opacity: 0.75 }}>{description}</Typography>
          </Box>
          <CheckRoundedIcon sx={{ fontSize: 19, visibility: value === selectedValue ? "visible" : "hidden" }} />
        </MenuItem>
      ))}
    </Select>
  );
}
